import Step2DmrHomepageContent from "./Steps/Step2DmrHomepageContent.jsx";
import DmrHomepage from "./Templates/DmrHomepage.jsx";
import dmrHomepageEditorConfig from "./EditorConfigs/dmrHomepageEditorConfig.js";

const dmrTemplates = {
  "dmr-homepage": {
    id: "dmr-homepage",
    name: "DMR-Homepage",
    label: "DMR Tennis",
    desc: "DMR Tennis homepage",
    pageType: "home",
    step2Component: Step2DmrHomepageContent,
    publicComponent: DmrHomepage,
    editorConfig: dmrHomepageEditorConfig,
  },
};

export default dmrTemplates;